var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_33683)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_42_33683",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_42_33683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.66602 15.8327V4.16602H10.2702C11.173 4.16602 12.0063 4.44379 12.7702 4.99935C13.5341 5.5549 13.916 6.32574 13.916 7.31185C13.916 8.02018 13.7563 8.56532 13.4368 8.94727C13.1174 9.32921 12.8188 9.60352 12.541 9.77018C12.8882 9.92296 13.2737 10.2077 13.6973 10.6243C14.1209 11.041 14.3327 11.666 14.3327 12.4993C14.3327 13.7355 13.8813 14.6 12.9785 15.0931C12.0757 15.5862 11.2285 15.8327 10.4368 15.8327H5.66602ZM8.18685 13.4993H10.3535C11.0202 13.4993 11.4264 13.3292 11.5723 12.9889C11.7181 12.6487 11.791 12.4021 11.791 12.2493C11.791 12.0966 11.7181 11.85 11.5723 11.5098C11.4264 11.1695 10.9993 10.9993 10.291 10.9993H8.18685V13.4993ZM8.18685 8.74935H10.1243C10.5827 8.74935 10.916 8.63129 11.1243 8.39518C11.3327 8.15907 11.4368 7.89518 11.4368 7.60352C11.4368 7.27018 11.3188 6.99935 11.0827 6.79102C10.8466 6.58268 10.541 6.47852 10.166 6.47852H8.18685V8.74935Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_33683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.f50585893d30b5c4b1d2bc4d297857b9.svg";
export { ForwardRef as ReactComponent };